import React, { createContext, useContext, useRef, useState } from 'react';
import { VideoJsPlayer } from 'video.js';

type PlayerContextValue = {
  player: VideoJsPlayer | null;
  registerPlayer: (player: VideoJsPlayer | null) => void;
};

const PlayerContext = createContext<PlayerContextValue>({
  player: null,
  registerPlayer: () => {
    // no-op
  }
});

export function PlayerProvider({ children }: { children: React.ReactNode }) {
  const [player, setPlayer] = useState<VideoJsPlayer | null>(null);
  const valueRef = useRef({ player, registerPlayer: setPlayer });
  valueRef.current.player = player;
  valueRef.current.registerPlayer = setPlayer;
  return (
    <PlayerContext.Provider value={valueRef.current}>
      {children}
    </PlayerContext.Provider>
  );
}

export function usePlayer() {
  return useContext(PlayerContext);
}
